(function() {
  function getVisibleThumbs($root) {
    var $visibleThumbs = $root.find('.product-page--thumbs:visible .product-media--thumb');
    if ($visibleThumbs.length) {
      return $visibleThumbs;
    }
    return $root.find('.product-page--thumbs .product-media--thumb').first().closest('.product-page--thumbs').find('.product-media--thumb');
  }

  function syncLazyImages($scope) {
    if (!window.lazySizes || !window.lazySizes.loader) {
      return;
    }

    $scope.find('img.lazyload').each(function() {
      try {
        window.lazySizes.loader.unveil(this);
      } catch (e) {}
    });

    try {
      if (typeof window.lazySizes.autoSizer !== 'undefined' && typeof window.lazySizes.autoSizer.checkElems === 'function') {
        window.lazySizes.autoSizer.checkElems();
      }
      if (typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }
    } catch (e) {}
  }

  function applyVariantMediaMarkup($root, mediaId) {
    var $map = $('[data-custom-variant-media-map]').first();
    var mediaMap = null;
    var mediaData = null;

    if (!$map.length) {
      return;
    }

    try {
      mediaMap = JSON.parse($map.text());
    } catch (e) {
      mediaMap = null;
    }

    if (!mediaMap) {
      return;
    }

    mediaData = mediaMap[String(mediaId)];
    if (!mediaData) {
      return;
    }

    $root.find('.product-media--featured[data-dynamic-variant="true"]').each(function() {
      $(this)
        .attr('data-id', mediaData.media_id)
        .attr('data-media-type', mediaData.media_type)
        .html(mediaData.slide_html);
      syncLazyImages($(this));
    });

    $root.find('.product-media--thumb[data-dynamic-variant-thumb="true"]').each(function() {
      $(this)
        .attr('data-id', mediaData.media_id)
        .html(mediaData.thumb_html);
      syncLazyImages($(this));
    });

    $root.find('.product-media--zoom-image[data-dynamic-variant="true"]').each(function() {
      $(this)
        .attr('data-id', mediaData.media_id)
        .html(mediaData.zoom_html);
      syncLazyImages($(this));
    });

    $root.find('[data-dynamic-variant-modal="true"]').each(function() {
      $(this).html(mediaData.modal_html);
      syncLazyImages($(this));
    });
  }

  function patchSwatchImages() {
    if (!window.theme || !theme.classes || !theme.classes.FrameworkRadios || theme.classes.FrameworkRadios.__customSwatchImagesPatched) {
      return;
    }

    theme.classes.FrameworkRadios.__customSwatchImagesPatched = true;

    theme.classes.FrameworkRadios.prototype.setSwatchAppearance = function() {
      return this.inputs.each(function() {
        var $input = $(this);
        var $swatch = $input.siblings('.radios--swatch-button');
        var swatchImage = $swatch.attr('data-swatch-image');
        var swatchColor;

        if (swatchImage) {
          $swatch.css({
            'background-image': 'url(' + swatchImage + ')',
            'background-color': 'transparent',
            'background-position': 'center',
            'background-repeat': 'no-repeat',
            'background-size': 'cover'
          });
          return;
        }

        swatchColor = $input.val().toLowerCase().replace(/\s+/g, '');
        if (theme.swatches[swatchColor] === void 0) {
          $swatch.css('background-color', swatchColor);
        } else if (theme.swatches[swatchColor].indexOf('cdn.shopify.com') > -1) {
          $swatch.css('background-image', 'url(' + theme.swatches[swatchColor] + ')');
        } else {
          $swatch.css('background-color', theme.swatches[swatchColor]);
        }
      });
    };
  }

  function patchVariantGallery() {
    if (!window.theme || !theme.classes || !theme.classes.FrameworkProduct || theme.classes.FrameworkProduct.__customVariantGalleryPatched) {
      return;
    }

    theme.classes.FrameworkProduct.__customVariantGalleryPatched = true;

    var originalUpdateVariantMedia = theme.classes.FrameworkProduct.prototype.updateVariantMedia;

    theme.classes.FrameworkProduct.prototype.updateVariantMedia = function(variantId) {
      applyVariantMediaMarkup(this.root, variantId);
      return originalUpdateVariantMedia.call(this, variantId);
    };
  }

  function bindSwipeGallery() {
    $('.product-page--root').each(function() {
      var $root = $(this);
      var $featuredRoot = $root.find('.product-media--root[data-view="featured"]').not('[data-media-size="mobile"]').first();
      var startX = 0;
      var startY = 0;

      if (!$featuredRoot.length || $featuredRoot.attr('data-custom-swipe-bound') === 'true') {
        return;
      }

      $featuredRoot.attr('data-custom-swipe-bound', 'true');

      $featuredRoot.on('touchstart.customVariantGallery', function(event) {
        var touch = event.originalEvent.touches && event.originalEvent.touches[0];
        if (!touch) {
          return;
        }
        startX = touch.clientX;
        startY = touch.clientY;
      });

      $featuredRoot.on('touchend.customVariantGallery', function(event) {
        var touch = event.originalEvent.changedTouches && event.originalEvent.changedTouches[0];
        var deltaX;
        var deltaY;
        var $thumbs;
        var activeIndex;
        var targetIndex;
        var $targetThumb;

        if (!touch) {
          return;
        }

        deltaX = touch.clientX - startX;
        deltaY = touch.clientY - startY;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        $thumbs = getVisibleThumbs($root);
        if (!$thumbs.length) {
          return;
        }

        activeIndex = $thumbs.index($thumbs.filter('[data-active="true"]').first());
        if (activeIndex < 0) {
          activeIndex = 0;
        }

        targetIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
        if (targetIndex < 0 || targetIndex >= $thumbs.length) {
          return;
        }

        $targetThumb = $thumbs.eq(targetIndex);
        if ($targetThumb.length) {
          $targetThumb.trigger('click');
        }
      });
    });
  }

  function initCustomVariantGallery() {
    patchSwatchImages();
    patchVariantGallery();
    bindSwipeGallery();
  }

  initCustomVariantGallery();
  $(document).on('shopify:section:load', initCustomVariantGallery);
})();
